/**
 * Utility functions for order payload construction
 */

/**
 * Build order payload for API submission
 *
 * @param {Object} params
 * @param {Object} params.customer - Customer details
 * @param {Array} params.products - Products in order
 * @param {Object} params.calculations - Order calculations
 * @param {string} params.restaurantId - Restaurant ID
 * @returns {Object} Order payload ready for API
 */
export const buildOrderPayload = ({
  customer,
  products,
  calculations,
  restaurantId,
}) => {
  return {
    name: customer.name.trim(),
    phoneNumber: customer.phone.trim(),
    address: customer.address?.trim() || "",
    pincode: "",
    orderType: customer.orderType,
    amount: calculations.grandTotal.toString(),
    gstAmount: calculations.gstAmount,
    packagingTotal: calculations.totalPackageCharge,
    paymentId: "",
    email: "",
    username: localStorage.getItem("username") || "admin",
    restaurantId,
    products: products.map((p) => buildProductPayload(p)),
  };
};

/**
 * Build individual product payload
 *
 * @param {Object} product - Product object
 * @returns {Object} Product payload
 */
const buildProductPayload = (product) => {
  // finalPrice already bakes in any selected add-ons; fall back to the
  // base offer/price only for products that never went through that path.
  const basePrice =
    Number(product.finalPrice) ||
    Number(product.offerPrice) ||
    Number(product.price) ||
    0;

  return {
    productId: product._id,
    productTitle: product.productName,
    quantity: product.quantity,
    price: Number(product.price) || basePrice,
    offerPrice: product.offerPrice || null,
    image: product.imageUrl || "",
    subTotal: product.quantity * basePrice,
    packageCharge: Number(product.packageCharge || 0),
    addOns: product.addOns || [],
  };
};
